// extracted by mini-css-extract-plugin
export default {"menuBlock":"LE-z","title":"ME-z","nav":"NE-z","flexCell":"OE-z","facetLink":"PE-z"};